import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { createOrganizacion, uploadToS3 } from "../../endpoints";
import Swal from "sweetalert2";
import CustomCircularProgress from "../../Components/Loading/CustomCircularProgress";
import CreateUsersForOrganizacion from "./CreateUsersForOrganizacion";  // Importamos el nuevo componente
import arrow from "./assets/arrow.svg"

const CrearOrganizacion = () => {
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const location = useLocation();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [loadingLogo, setLoadingLogo] = useState(false);
  const [formValues, setFormValues] = useState({
    nombre: "",
    rubro: "",
    direccion: "",
    contacto: "",
    localidad: "",
    telefono: "",
    provincia: "",
    informacionAdicional: "",
    logo: null,
  });

  const [usuarios, setUsuarios] = useState([]); // Estado para manejar los usuarios

  useEffect(() => {
    if (location.pathname === "/organizaciones/editar/" + params?.id) {
      setIsEdit(true);
      setFormValues({
        nombre: "ejemplo",
        rubro: "ejemplo",
        direccion: "ejemplo",
        contacto: "ejemplo",
        localidad: "ejemplo",
        telefono: "ejemplo",
        provincia: "ejemplo",
        informacionAdicional: "ejemplo",
        logo: null,
      });
    }
  }, [location.pathname, params?.id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  // Función para manejar la carga del archivo
  const handleFileChange = (e) => {
    if (e.target.name === "logo") {
      e.preventDefault();
      setLoadingLogo(true);

      const formData = new FormData();
      formData.append('file', e.target.files[0]);

      uploadToS3(formData)
        .then((response) => {
          if (response?.status === 200) {
            setFormValues({
              ...formValues,
              logo: response.data.photoUrl,
            });
          }
          setLoadingLogo(false);
        })
        .catch((error) => {
          console.error('Error al cargar el logo:', error);
          setLoadingLogo(false);
        });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (
      formValues.nombre &&
      formValues.rubro &&
      formValues.direccion &&
      formValues.contacto &&
      formValues.localidad &&
      formValues.telefono &&
      formValues.provincia &&
      formValues.logo &&
      usuarios.length > 0 // Validar que haya usuarios agregados
    ) {
      createOrganizacion({ formValues, usuarios })
        .then((res) => {
          if (res.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Se creó con éxito",
              confirmButtonText: "Listo",
              confirmButtonColor: "#003049",
            });
            setLoading(false);
            navigate("/organizaciones");
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              confirmButtonText: "Listo",
              confirmButtonColor: "#003049",
            });
            setLoading(false);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            confirmButtonText: "Listo",
            confirmButtonColor: "#003049",
          });
          console.error(error);
          setLoading(false);
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Complete los campos obligatorios y agregue al menos un usuario",
        confirmButtonText: "Listo",
        confirmButtonColor: "#003049",
      });
      console.log(formValues.nombre,
        formValues.rubro,
        formValues.direccion,
        formValues.contacto,
        formValues.localidad,
        formValues.telefono,
        formValues.provincia,
        formValues.informacionAdicional,
        formValues.logo,
        usuarios)
      setLoading(false);
    }
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <FlexRow1 >
        <IconArrow src={arrow} alt="icon-volver" onClick={() => navigate("/organizaciones")}/>
        {isEdit ? <Title>Editar organización</Title> : <Title>Cargar nueva organización</Title>}
      </FlexRow1>

      <FormGrid>
        <InputContainer>
          <Label htmlFor="nombre">Nombre</Label>
          <Input
            id="nombre"
            name="nombre"
            value={formValues.nombre}
            onChange={handleInputChange}
            placeholder="Ingrese nombre"
          />
        </InputContainer>
        <InputContainer>
          <Label htmlFor="rubro">Sector/Rubro</Label>
          <Input
            id="rubro"
            name="rubro"
            value={formValues.rubro}
            onChange={handleInputChange}
            placeholder="Ingrese rubro"
          />
        </InputContainer>
        <InputContainer>
          <Label htmlFor="direccion">Dirección</Label>
          <Input
            id="direccion"
            name="direccion"
            value={formValues.direccion}
            onChange={handleInputChange}
            placeholder="Ingrese dirección"
          />
        </InputContainer>
        <InputContainer>
          <Label htmlFor="contacto">Contacto Responsable</Label>
          <Input
            id="contacto"
            name="contacto"
            value={formValues.contacto}
            onChange={handleInputChange}
            placeholder="Ingrese nombre"
          />
        </InputContainer>
        <InputContainer>
          <Label htmlFor="localidad">Localidad</Label>
          <Input
            id="localidad"
            name="localidad"
            value={formValues.localidad}
            onChange={handleInputChange}
            placeholder="Ingrese localidad"
          />
        </InputContainer>
        <InputContainer>
          <Label htmlFor="telefono">Teléfono</Label>
          <Input
            id="telefono"
            name="telefono"
            value={formValues.telefono}
            onChange={handleInputChange}
            placeholder="Ingrese teléfono"
          />
        </InputContainer>
        <InputContainer>
          <Label htmlFor="provincia">Provincia</Label>
          <Input
            id="provincia"
            name="provincia"
            value={formValues.provincia}
            onChange={handleInputChange}
            placeholder="Ingrese provincia"
          />
        </InputContainer>
        <InputContainer>
          <Label htmlFor="informacionAdicional">Información adicional</Label>
          <Textarea
            id="informacionAdicional"
            name="informacionAdicional"
            value={formValues.informacionAdicional}
            onChange={handleInputChange}
            placeholder="Ingrese más información"
          />
        </InputContainer>
        {loadingLogo ? (
          <CustomCircularProgress size={"40px"} />
        ) : (
          <InputContainer>
            <Label htmlFor="logo">Logo de la Organización</Label>
            <Input type="file" id="logo" accept="image/*" name="logo" onChange={handleFileChange} />
            {formValues.logo && (
              <LogoPreview>
                <img src={formValues.logo} alt="Logo Preview" />
              </LogoPreview>
            )}
          </InputContainer>
        )}
      </FormGrid>

      <CreateUsersForOrganizacion usuarios={usuarios} setUsuarios={setUsuarios} /> {/* Aquí incluimos el nuevo componente */}

      {loading ? (
        <CustomCircularProgress size={"40"} />
      ) : (
        <ButtonContainer>
          <CancelButton type="button" onClick={() => navigate("/organizaciones")}>
            Cancelar
          </CancelButton>
          <SubmitButton type="submit">Guardar</SubmitButton>
        </ButtonContainer>
      )}
    </FormContainer>
  );
};

export default CrearOrganizacion;
const IconArrow = styled.img`
  width: 24px;
  height: 24px;
`;
// Styled components
const FlexRow1 = styled.div`
  width:auto;
  display:flex;
  flex-direction:row;
  align-items:center;
  cursor:pointer;
`;

const FormContainer = styled.form`
  background-color: #ffffff;
  width: 100%;
  margin: auto;
  padding: 32px;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height:calc(100vh - 100px);
  gap:16px;
`;

const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #003049;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 24px;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
`;

const Input = styled.input`
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
  &::placeholder {
    color: #999;
  }
`;

const Textarea = styled.textarea`
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #333;
  &::placeholder {
    color: #999;
  }
  resize: none;
`;

const LogoPreview = styled.div`
  margin-top: 16px;
  img {
    max-width: 100px;
    max-height: 100px;
    border-radius: 8px;
    object-fit: cover;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;

const CancelButton = styled.button`
  padding: 12px 24px;
  background-color: transparent;
  border: 1px solid #003049;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #003049;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const SubmitButton = styled.button`
  padding: 12px 24px;
  background-color: #003049;
  border: none;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    background-color: #002538;
  }
`;
